module.exports = "https://la-static.vkplay.ru/promo/universal/img/pic-2.6945e790.png";